import { SelectOption } from '@/components/common/SelectDropdown';

export const bankOptions: SelectOption[] = [
  { label: 'State Bank of India', value: 'state_bank_of_india' },
  { label: 'HDFC Bank', value: 'hdfc_bank' },
  { label: 'ICICI Bank', value: 'icici_bank' },
  { label: 'Axis Bank', value: 'axis_bank' },
  { label: 'Punjab National Bank', value: 'punjab_national_bank' },
  { label: 'Bank of Baroda', value: 'bank_of_baroda' },
  { label: 'Canara Bank', value: 'canara_bank' },
  { label: 'Union Bank of India', value: 'union_bank_of_india' },
  { label: 'IDBI Bank', value: 'idbi_bank' },
  { label: 'yes_bank', value: 'yes_bank' },
  { label: 'Kotak Mahindra Bank', value: 'kotak_mahindra_bank' },
  { label: 'IndusInd Bank', value: 'indusind_bank' },
  { label: 'Central Bank of India', value: 'central_bank_of_india' },
  { label: 'Indian Bank', value: 'indian_bank' },
  { label: 'Indian Overseas Bank', value: 'indian_overseas_bank' },
  { label: 'UCO Bank', value: 'uco_bank' },
  { label: 'Bank of Maharashtra', value: 'bank_of_maharashtra' },
  { label: 'Federal Bank', value: 'federal_bank' },
  { label: 'South Indian Bank', value: 'south_indian_bank' },
  { label: 'IDFC First Bank', value: 'idfc_first_bank' },
];

export const getBankOptionLabel = (value: string) => {
  return bankOptions.find((opt) => opt.value === value)?.label || value;
};
